<template>
  <div class="d-flex">
    <v-avatar
      color="teal"
      style="margin-left: -1em; color: #ffffff; border: 1px solid white !important;"
      v-for="(user, usrIdx) in value"
      :key="usrIdx"
      :size="iconSize"
    >
      {{ user.userFirstName[0].toUpperCase()
      }}{{ user.userLastName[0].toUpperCase() }}
    </v-avatar>
  </div>
</template>

<script>
export default {
  props: {
    value: [Array, String, Object],
    size:String
  },
  data() {
    return {
      innerValue: "",
      dialog: false,
      iconSize: this.size || 30
    };
  },
  computed: {
    firstUser() {
      if (this.value.length > 0) {
        return `${this.value[0].userFirstName} ${this.value[0].userLastName[0]}`;
      }
      return "";
    },
    others() {
      if (this.value.length > 1) {
        return " " + (this.value.length - 1) + " Other users";
      }
      return "";
    },
  },
  methods: {
    showDetail() {
      this.dialog = true;
    },
  },
};
</script>

<style scoped>
</style>